// app/javascript/src/containers/Scheduling/eventTypeReducer.ts
import { EventType, WeekdaySchedule } from '../../types'

export interface EditorState {
  saved: EventType | null
  draft: EventType | null
  hostBookingSlug: string
}

export type EditorAction =
  | { type: 'loaded', eventType: EventType }
  | { type: 'change', patch: Partial<EventType> }
  | { type: 'hostSlug', value: string }
  | { type: 'saved', eventType: EventType }
  | { type: 'scheduleRefreshed', weekSchedule: WeekdaySchedule[] }
  | { type: 'activeSaved', active: boolean }

export const initialEditorState: EditorState = { saved: null, draft: null, hostBookingSlug: '' }

export function eventTypeReducer(state: EditorState, action: EditorAction): EditorState {
  switch (action.type) {
    case 'loaded':
    case 'saved':
      return { saved: action.eventType, draft: action.eventType, hostBookingSlug: action.eventType.booking_slug || '' }
    case 'change':
      return state.draft ? { ...state, draft: { ...state.draft, ...action.patch } } : state
    case 'hostSlug':
      return { ...state, hostBookingSlug: action.value }
    case 'scheduleRefreshed':
      // Schedule lives on the host, not the event type: update both copies so it doesn't mark the form dirty
      return {
        ...state,
        saved: state.saved && { ...state.saved, week_schedule: action.weekSchedule },
        draft: state.draft && { ...state.draft, week_schedule: action.weekSchedule },
      }
    case 'activeSaved':
      // Persisted immediately: update both copies so other unsaved edits stay dirty and active doesn't
      return {
        ...state,
        saved: state.saved && { ...state.saved, active: action.active },
        draft: state.draft && { ...state.draft, active: action.active },
      }
  }
}

export function isDirty(state: EditorState): boolean {
  if (!state.saved || !state.draft) return false
  return JSON.stringify(state.saved) !== JSON.stringify(state.draft) || (state.saved.booking_slug || '') !== state.hostBookingSlug
}

// Fields the preview slots endpoint accepts as overrides
export const OVERRIDE_KEYS: Array<keyof EventType> = [
  'duration', 'durations', 'before_event_buffer', 'after_event_buffer', 'minimum_booking_notice', 'slot_interval',
  'booking_frequency_limit', 'booking_duration_limit', 'period_type', 'period_days', 'period_count_calendar_days',
  'period_start_date', 'period_end_date', 'only_first_slot_per_day',
]
